import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const VerdictContainer = styled(FlexView)`
  margin-bottom: 16px;
`;

export const ButtonsWrapper = styled(FlexView)`
  gap: 16px;
  margin-left: 16px;
`;

export const VerdictButton = styled.button`
  padding: 8px 20px;
  cursor: pointer;
  border: 1.5px solid;
  transition: all 0.15s ease;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ValidButton = styled(VerdictButton)`
  border-color: ${COLORS.GREEN_6};
  background: ${({ isSelected }) => (isSelected ? COLORS.GREEN_6 : COLORS.GREEN_1)};
  color: ${({ isSelected }) => (isSelected ? COLORS.WHITE : COLORS.GREEN_6)};

  &:hover:not(:disabled) {
    background: ${COLORS.GREEN_6};
    color: ${COLORS.WHITE};
    * {
      color: ${COLORS.WHITE} !important;
    }
  }
`;

export const InvalidButton = styled(VerdictButton)`
  border-color: ${COLORS.RED_6};
  background: ${({ isSelected }) => (isSelected ? COLORS.RED_6 : COLORS.RED_1)};
  color: ${({ isSelected }) => (isSelected ? COLORS.WHITE : COLORS.RED_6)};

  &:hover:not(:disabled) {
    background: ${COLORS.RED_6};
    color: ${COLORS.WHITE};
    * {
      color: ${COLORS.WHITE} !important;
    }
  }
`;

export const ReasonBlock = styled(FlexView)`
  gap: 8px;
`;

export const ReasonDropdownWrapper = styled(FlexView)`
  width: 220px;
  > div {
    padding: 0;
  }
  && input {
    height: 40px;
    padding: 0 12px;
    font-size: 14px;
  }
`;
